import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import vuetify from "./plugins/vuetify";
import admin from "./plugins/admin";
import "./plugins/i18n";
import "./plugins/base";
import "./plugins/custom";
import "./plugins/chartist";
import "./sass/overrides.sass";
import HiddenInput from "./components/inputs/HiddenInput";
import HorizontalFileInput from "./components/inputs/HorizontalFileInput";
import { helpers } from "./utils/helpers.js";

Vue.prototype.$helpers = helpers;

Vue.config.productionTip = false;

Vue.component("VaHiddenInput", HiddenInput);
Vue.component("CustomHorizontalFileInput", HorizontalFileInput);

new Vue({
  router,
  store,
  i18n,
  vuetify,
  admin,
  render: (h) => h(App),
}).$mount("#app");
